var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNumber({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0421 76.4458C74.3807 82.7722 66.2044 88.4147 57.6029 93.3112C55.2853 94.9271 52.6769 96.0541 49.9297 96.6266C46.7881 96.8984 43.6402 96.1774 40.91 94.5605C40.91 94.5605 40.8005 94.5605 40.7692 94.4644C40.0344 94.096 39.3153 93.6796 38.5961 93.2471C30.7788 88.4422 23.8828 81.3949 20.9562 72.5217C20.4294 70.8913 20.0315 69.2202 19.7662 67.5245C19.7662 67.5245 19.7662 67.5245 19.7662 67.5245C19.0578 62.6241 19.3592 57.6263 20.651 52.8534C22.4646 46.4109 25.595 40.438 29.8345 35.3313C34.7932 28.8717 41.4998 24.053 49.1168 21.4769C52.0916 20.5446 55.1805 20.0485 58.2914 20.0034C67.6697 19.8753 77.1589 23.3669 85.4919 28.0117C87.1041 28.8869 88.6697 29.8492 90.1823 30.8947C92.9601 32.6885 95.3973 34.984 97.3752 37.6697C106.759 51.3638 91.7764 67.925 82.0421 76.4458Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7989 91.5725C87.6792 95.2688 83.9353 98.391 79.7368 100.798L79.5049 100.924C68.9617 106.961 56.4487 108.569 44.7184 105.394C32.9882 102.219 23.0016 94.5213 16.9556 83.9945C10.9096 73.4677 9.29955 60.9739 12.4795 49.2617C15.6595 37.5494 23.3691 27.5781 33.9122 21.5413L34.4473 21.2346C58.8686 7.34575 86.9882 12.2498 98.4952 32.3763C101.775 38.423 103.646 45.1305 103.969 51.9994",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7153 74.7671C71.7109 40.3972 69.4301 44.3947 52.9703 43.4288C50.1923 42.2763 55.7483 32.2514 58.2755 31.7784C61.2273 31.21 79.2998 31.3268 86.5624 36.5052C100.123 46.1355 95.3906 53.9138 96.8281 68.1542C97.066 70.5076 102.165 73.5064 100.159 74.1531C92.4389 76.6633 84.1192 74.6432 76.0674 74.8797L73.7153 74.7671Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5009 53.5205C62.5009 53.5205 39.1588 53.9835 37.8667 53.0133",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7183 65.8583C37.7183 65.8583 51.762 65.7315 53.3205 65.7315C54.879 65.7315 62.3696 64.9978 62.3696 64.9978",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3621 75.1258C55.3621 75.1258 46.0951 75.9008 45.2944 75.415C44.4924 74.9292 39.8325 74.6385 39.8325 74.6385",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0364 51.2719C88.0364 51.2719 78.7694 52.0469 77.9688 51.5611C77.1681 51.0753 72.5068 50.7847 72.5068 50.7847",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0408 62.899C90.0408 62.899 80.7738 63.6739 79.9731 63.1881C79.1711 62.7024 74.5112 62.4117 74.5112 62.4117",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5613 62.4751C72.5613 62.4751 76.1342 45.2232 62.2514 43.488C48.3673 41.7528 33.5657 42.5691 28.7676 52.9815C23.9695 63.3939 28.155 75.1327 26.4199 79.0118C24.6847 82.891 22.5407 85.4425 24.5821 85.9539C26.6236 86.4639 64.2914 87.2816 66.538 85.8513C68.7832 84.4225 73.5813 76.3592 72.5613 62.4751Z",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8916 74.5931C84.7201 75.7271 100 75.0875 100.164 74.1544C100.384 72.8551 98.9205 73.8979 96.8335 68.1525C94.7294 62.4057 99.999 41.3615 88.5979 34.9565C77.1968 28.5515 70.4072 26.1182 53.9017 36.109C53.9017 36.109 53.3704 38.8357 52.8774 42.7889",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNumber);
export default __webpack_public_path__ + "static/media/no-number.d67793c29d5f11491975c2d2dfb164fe.svg";
export { ForwardRef as ReactComponent };